import React, { useState, useCallback } from "react";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";

import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import Loader from "../../Common/Loader/Loader";
import { api, subCategoryUploadDir } from "../../../config";
import messages from "../../../locale/messages";
import debounce from "../../../helpers/debounce";
import { removeOrderItemAction } from "../../../actions/order/removeOrderItemAction";
import { addOrder } from "../../../actions/order/addOrder";
import increment from '../../../../public/Icons/defaultIncrementIcon.svg';
import decrement from '../../../../public/Icons/defaultDecrementIcon.svg';
import bt from '../../commonStyle.css';
import s from './OrderItems.css';




const OrderItems = (props) => {

    const {
        data,
        multiplierValue,
        basePrice,
        totalQuantities,
        image,
        name,
        pricingType,
        categoryId,
        currency,
        isLastOrderItem,
        intl: { formatMessage }
    } = props

    const [totalQuantity, setTotalQuantity] = useState(totalQuantities || 1)
    const dispatch = useDispatch()
    const addOrderLoading = useSelector(state => state.loader.addOrderLoading)
    const promoId = useSelector(state => formValueSelector('PromoCodeForm')(state, 'promoId'))
    const subCategoryId = data?.subCategoryDetails?.id;
    const removeOrderLoading = useSelector(
        state => state.loader.removeOrderLoading?.[subCategoryId]
    );

    const handleClick = async (e) => {
        e.preventDefault();
        let subCategoryId, orderId
        subCategoryId = data?.subCategoryDetails?.id, orderId = data?.orderId;
        await dispatch(removeOrderItemAction({ categoryId, subCategoryId, orderId, isLastOrderItem, promoId }))
    }

    const handleIncrement =
        debounce(async () => {
            if (totalQuantity < multiplierValue) {
                const newQuantity = totalQuantity + 1;
                setTotalQuantity(newQuantity);

                const subCategoryId = data?.subCategoryDetails?.id;
                const minimumHours = pricingType === 'hourly' ? multiplierValue : 0;
                const quantity = pricingType === 'fixed' ? newQuantity : 0;

                await dispatch(addOrder({ categoryId, subCategoryId, totalQuantity: quantity, currency, minimumHours, promoId }));
            }
        }, 300)

    const handleDecrement =
        debounce(async () => {
            const newQuantity = totalQuantity - 1;
            const subCategoryId = data?.subCategoryDetails?.id;
            const minimumHours = pricingType === 'hourly' ? multiplierValue : 0;
            if (newQuantity <= 0) {
                const orderId = data?.orderId;
                await dispatch(removeOrderItemAction({ categoryId, subCategoryId, orderId, isLastOrderItem, promoId }));
            } else {
                setTotalQuantity(newQuantity);
                const quantity = pricingType === 'fixed' ? newQuantity : 0;

                await dispatch(addOrder({ categoryId, subCategoryId, totalQuantity: quantity, currency, minimumHours, promoId }));
            }
        }, 300)
    const isIncrementDisabled = totalQuantity >= multiplierValue;
    const isDisabled = currency === null;

    return (
        <div className={s.orderCardItemContainer}>
            <div className={s.orderCardItemImgContainer}>
                <img src={`${api.apiEndpoint}${subCategoryUploadDir}medium_${image}`} alt={name} width={30} height={30} />
            </div>
            <div className={s.orderCardItemInfoType}>
                <div className={s.orderCardItemInfoTypeWrapper}>
                    {pricingType === 'hourly' ?
                        <div className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.textAlignStart)}>{name}</div> :
                        <div className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.textAlignStart)}>{name} ({totalQuantity})</div>
                    }
                    <div className={cx(bt.commonSize14, bt.fontWeight400, bt.secondaryColor, bt.textAlignStart)}>
                        {
                            (
                                pricingType === 'hourly' ? (
                                    <>
                                        <span className={bt.displayInlineBlock}>
                                            <FormattedMessage {...messages.minHourLabel} />&nbsp;
                                        </span>
                                        <span className={bt.displayInlineBlock}>
                                            {multiplierValue}&nbsp;
                                        </span>
                                        <span className={bt.displayInlineBlock}>
                                            <FormattedMessage {...messages.hoursLabel} />
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span className={bt.displayInlineBlock}>
                                            <FormattedMessage {...messages.maxQuantityLabel} />&nbsp;
                                        </span>
                                        <span className={bt.displayInlineBlock}>
                                            {multiplierValue}
                                        </span>
                                    </>
                                )
                            )
                        }
                    </div>
                    <div className={cx(bt.commonSize16, bt.fontWeight600, bt.themeColor, bt.textAlignStart)}>
                        <CurrencyConverter amount={basePrice} from={currency} />&nbsp;
                        <span className={bt.displayInlineBlock}>
                            {'/'}&nbsp;
                        </span>
                        {pricingType !== 'fixed' ? (
                            <FormattedMessage {...messages.hourLabel} />
                        ) : (
                            <FormattedMessage {...messages.quantityText} />
                        )}
                    </div>
                </div>
                {(pricingType !== 'fixed' ?
                    <div className={s.orderItemsBtnContainer}>
                        <Loader
                            type='button'
                            buttonType='submit'
                            handleClick={(e) => handleClick(e)}
                            label={formatMessage(messages.remove)}
                            show={removeOrderLoading}
                            className={cx(bt.btnSecondary, bt.smallBtn)}
                            isSecondary
                        />
                    </div>
                    :
                    <div className={s.orderItemsRangeBtn}>
                        <span onClick={!isDisabled && !addOrderLoading ? handleDecrement : undefined} disabled={addOrderLoading || isDisabled} className={s.orderItemsRangeBtnIcon}>
                            <img src={decrement} alt="decrement" />
                        </span>
                        {totalQuantity}
                        <span disabled={isIncrementDisabled || addOrderLoading || isDisabled} onClick={!isDisabled && !addOrderLoading ? handleIncrement : undefined} className={cx(s.orderItemsRangeBtnIcon, { [s.orderItemsRangeDisabledBtnIcon]: isIncrementDisabled })}>
                            <img src={increment} alt="increment" />
                        </span>
                    </div>
                )}
            </div>
        </div >
    );
}

export default injectIntl(withStyles(bt, s)(OrderItems));
